import { Permission } from '_metronic/helpers'
import { useAuth } from '../../../../auth'

/**
 * Grupos que recebem as permissões `Lotacao:*` no seed do backend
 * (`lauduzone-backend/src/main/resources/permission.json`). Hoje `Lotacao:read`,
 * `Lotacao:create`, `Lotacao:update` e `Lotacao:delete` são concedidas exatamente aos mesmos
 * quatro grupos — por isso as duas listas abaixo têm o mesmo conteúdo, mas ficam separadas para
 * que uma eventual divergência no backend (ex.: leitura liberada para `MEDICO`) seja refletida
 * aqui sem confundir leitura com escrita.
 *
 * LIMITAÇÃO CONHECIDA (arquitetura, a mesma descrita em
 * `unidades/unidades-list/core/_esusPermissao.ts`): o frontend não consegue checar a permissão
 * pelo nome — `/usuarios/me` não devolve `grupo.perfis`, então a única informação de autorização
 * disponível no cliente é o NOME DO GRUPO (`currentUser.grupo.nome`). O backend continua sendo a
 * autoridade real e devolve 403 em qualquer divergência.
 */
export const GRUPOS_LOTACAO_LEITURA: Permission[] = [
  Permission.SuperAdmin,
  Permission.SuperGerente,
  Permission.SuperMedico,
  Permission.Admin,
]

export const GRUPOS_LOTACAO_ESCRITA: Permission[] = [
  Permission.SuperAdmin,
  Permission.SuperGerente,
  Permission.SuperMedico,
  Permission.Admin,
]

export const MSG_SEM_PERMISSAO_LOTACAO =
  'Você não tem permissão para cadastrar, editar ou inativar lotações. ' +
  'Solicite ao administrador da instituição a permissão "Lotacao:create"/"Lotacao:update".'

/** Indica se o usuário autenticado pode consultar as lotações de um profissional. */
export const usePermissaoLotacaoLeitura = (): boolean => {
  const { currentUser } = useAuth()
  return GRUPOS_LOTACAO_LEITURA.includes(currentUser?.grupo?.nome as Permission)
}

/** Indica se o usuário autenticado pode criar, editar, inativar ou reativar lotações. */
export const usePermissaoLotacaoEscrita = (): boolean => {
  const { currentUser } = useAuth()
  return GRUPOS_LOTACAO_ESCRITA.includes(currentUser?.grupo?.nome as Permission)
}
